import { IPayments } from 'modules/_common/models';
import API from 'services/api';

export const getMarkAsPaidPayments = (invoiceId: string): Promise<IPayments> =>
  API.get(`/api/documents/invoices/${invoiceId}/payments`).then(response => response?.data);
